<template>
    <rkm-form
        v-if="model"
        ref="RkmFormVeiculo"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-input
                    label="Placa"
                    :validations="validations.numeroPlaca"
                    v-model="model.numeroPlaca"
                    v-mask="placaMask"
                    type="text"
                    uppercase
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-checkbox
                                v-model="model.padraoPlacaMercosul"
                                @change="limpaNumeroPlaca()"
                            >
                                Mercosul
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-select
                    :options="form.marcas"
                    :validations="validations.marcaId"
                    label="Marca"
                    text-field="descricao"
                    value-field="id"
                    v-model="model.marcaId"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="5">
                <rkm-form-input
                    label="Modelo"
                    :validations="validations.descricaoModelo"
                    v-model="model.descricaoModelo"
                    type="text"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-select
                    :options="form.cores"
                    :validations="validations.corId"
                    label="Cor predominante"
                    text-field="descricao"
                    value-field="id"
                    v-model="model.corId"
                    show-default-option
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-input
                    label="Ano de Fabricação"
                    :validations="validations.anoFabricacao"
                    v-model="model.anoFabricacao"
                    type="number"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    label="KM inicial"
                    :validations="validations.kilometroInicial"
                    v-model="model.kilometroInicial"
                    type="number"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-select
                    :options="form.combustiveis"
                    :validations="validations.combustivelId"
                    label="Combustível"
                    text-field="descricao"
                    value-field="id"
                    v-model="model.combustivelId"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    label="Renavam"
                    :validations="validations.numeroRenavam"
                    v-model="model.numeroRenavam"
                    type="number"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Número do chassi"
                    :validations="validations.numeroChassi"
                    v-model="model.numeroChassi"
                    uppercase
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-date-picker
                    :max-date="form.dataAtual"
                    label="Data de aquisição"
                    slim
                    :validations="validations.dataAquisicao"
                    v-model="model.dataAquisicao"
                    type="number"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    label="Número de eixos"
                    :validations="validations.numeroEixos"
                    v-model="model.numeroEixos"
                    type="number"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-select
                    :options="form.tipos"
                    :validations="validations.tipoId"
                    label="Tipo de veículo"
                    text-field="descricao"
                    value-field="id"
                    v-model="model.tipoId"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    label="Capacidade"
                    :validations="validations.numeroCapacidade"
                    v-model="model.numeroCapacidade"
                    type="number"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="form.tiposPassageiros"
                    :validations="validations.tipoPassageiroId"
                    label="Tipo de passageiro"
                    text-field="descricao"
                    value-field="id"
                    v-model="model.tipoPassageiroId"
                    show-default-option
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="5">
                <rkm-form-input
                    label="Nome do proprietário"
                    :validations="validations.nomeProprietario"
                    v-model="model.nomeProprietario"
                    type="text"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    label="CNPJ do proprietário"
                    placeholder="99.999.999/9999-99"
                    uppercase
                    :validations="validations.numeroCnpjProprietario"
                    v-model="model.numeroCnpjProprietario"
                    v-mask="mask.cnpj"
                    type="text"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Prefixo"
                    :validations="validations.prefixo"
                    v-model="model.prefixo"
                    type="text"
                    uppercase
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="5">
                <rkm-form-input
                    label="Patrimônio"
                    :validations="validations.numeroPatrimonio"
                    v-model="model.numeroPatrimonio"
                    type="number"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-checkbox
                    :label="false"
                    inline
                    v-model="model.bloqueado"
                >
                    Inativar
                </rkm-form-checkbox>

                <rkm-form-checkbox
                    :label="false"
                    inline
                    v-model="model.tipoAmbulancia"
                >
                    Ambulância
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Mixins.
import { error, repository, stringCase, mask, unmask, object } from '@/mixins'

// Moment.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        placaMask() {
            return this.model.padraoPlacaMercosul ?
                this.mask.numeroPlacaPadraoMercosul :
                this.mask.numeroPlacaPadraoDetran
        },
        validations() {
            return {
                numeroPlaca: {
                    required: true,
                    min_max_without_mask: 7,
                },
                descricaoModelo: {
                    required: true,
                    max: 56,
                },
                numeroCapacidade: {
                    required: true,
                    max: 3,
                },
                anoFabricacao: {
                    required: true, min: 4,
                    max: 4,
                },
                numeroPatrimonio: {
                    required: false,
                    max: 10,
                },
                prefixo: {
                    required: false,
                    max: 3,
                },
                kilometroInicial: {
                    required: true,
                    max: 11,
                },
                numeroRenavam: {
                    required: true,
                    max: 11,
                },
                numeroEixos: {
                    required: true,
                    max: 2,
                },
                numeroChassi: {
                    required: true,
                    max: 17,
                },
                dataAquisicao: {
                    required: true,
                },
                numeroCnpjProprietario: {
                    required: true,
                    min_max_without_mask: 14,
                    cnpj: true,
                },
                nomeProprietario: {
                    required: true,
                    min: 4,
                    max: 72,
                    name: true,
                },
                bloqueado: {
                    required: true,
                },
                tipoAmbulancia: {
                    required: true,
                },
                marcaId: {
                    required: true,
                },
                tipoId: {
                    required: true,
                },
                tipoPassageiroId: {
                    required: true,
                },
                corId: {
                    required: true,
                },
                combustivelId: {
                    required: true
                },
            }
        },
    },
    created() {
        this.repositories = {
            veiculo: this.getConectaSusRepository('transportePaciente.veiculo')
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        limpaNumeroPlaca() {
            this.model.numeroPlaca = ''
        },
        convertBooleanToBinary(valor) {
            return valor ? 1 : 0
        },
        trataNull(valor) {
            return valor === undefined || valor == null ? null : valor
        },
        load() {
            this.setLoading()

            const request = this.id ?
                this.repositories.veiculo.edit(this.id) :
                this.repositories.veiculo.create()

            request
                .then(({ data }) => this.setData(data.form, data.model || null))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(form, model) {
            if (form) {

                this.form = Object.assign(form)
            }

            if (model) {

                this.model = Object.assign(model)

                this.model.bloqueado = this.model.bloqueado == 1
                this.model.tipoAmbulancia = this.model.tipoAmbulancia == 1
                this.model.padraoPlacaMercosul = this.model.padraoPlacaMercosul == 1
            }
        },
        save() {
            this.$refs.RkmFormVeiculo.validate()
                .then(valid => {
                    if (valid) {
                        this.setLoading()

                        const modelSnakeCase = this.prepareData()

                        const request = modelSnakeCase.id === undefined || modelSnakeCase.id === null ?
                            this.repositories.veiculo.store(modelSnakeCase) :
                            this.repositories.veiculo.update(modelSnakeCase.id, modelSnakeCase)

                        request
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        prepareData() {
            const veiculo = this.clone(this.model)

            veiculo.id = this.trataNull(veiculo.id)
            veiculo.numeroPatrimonio = this.trataNull(veiculo.numeroPatrimonio)
            veiculo.prefixo = this.trataNull(veiculo.prefixo)

            veiculo.bloqueado = this.convertBooleanToBinary(veiculo.bloqueado)
            veiculo.tipoAmbulancia = this.convertBooleanToBinary(veiculo.tipoAmbulancia)
            veiculo.padraoPlacaMercosul = this.convertBooleanToBinary(veiculo.padraoPlacaMercosul)
            veiculo.dataAquisicao = moment(this.model.dataAquisicao).format('YYYY-MM-DD')

            if (veiculo.numeroPlaca) {

                veiculo.numeroPlaca = this.unMaskPlaca(veiculo.numeroPlaca)
            }

            if (veiculo.numeroCnpjProprietario) {

                veiculo.numeroCnpjProprietario = this.unMaskCnpj(veiculo.numeroCnpjProprietario)
            }

            return this.camelObjectKeysToSnakeRecursive(veiculo)
        },
    },
    mixins: [ error, repository, stringCase, mask, unmask, object ],
    mounted() {
        this.load()
    },
    props: {
        id: { type: [Number], default: null }
    }
}
</script>